export const ADMIN_PASSWORD = 'kanus2024';
export const AUTH_KEY = 'kanus_admin_auth';
